/**
 * Combina los parámetros de la URL del browser con parámetros adicionales
 * @param {Object} othersParams - Parámetros adicionales para combinar con los de la URL
 * @param {Array} excludeParams - Parámetros a excluir de la URL
 * @returns {Object} - Objeto combinado de parámetros
 */
const getURLSearchParamsWithOthers = (othersParams = {}, excludeParams = null) => {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlParams.entries());

  const filteredParams = excludeParams
    ? Object.fromEntries(Object.entries(queryParams).filter(([key]) => !excludeParams.includes(key)))
    : queryParams;

  return {
    ...filteredParams,
    ...othersParams,
  };
};

export default getURLSearchParamsWithOthers;
